import {
  Project,
  ProjectVirtualGraph,
  ProjectsState,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

// prevState must be typed as `any` since it's an older version of the Redux State
export const v2 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v2Projects(prevState.projects);
  }

  return nextState;
};

const v2Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const virtualGraphsById: Record<string, ProjectVirtualGraph> = {};

    Object.entries(project.virtualGraphsById).forEach(
      ([virtualGraphId, virtualGraph]) => {
        virtualGraphsById[virtualGraphId] = {
          ...virtualGraph,
          previewRows: [],
        };
      }
    );

    projectsById[projectId] = {
      ...project,
      virtualGraphsById,
    };
  });

  return { ...prevProjectsState, projectsById };
};
